// @ts-nocheck

import difference from "set.prototype.difference";
import intersection from "set.prototype.intersection";
import union from "set.prototype.union";

union.shim();
intersection.shim();
difference.shim();
